import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";



import userReducer from "./user/userReducer";
import listUsersReducer from "./listUsers/listUsersReducer";
import setHideNavbarReducer from "./hideNavBar/hideNavbarReducer";
import listVansReducer from "./listVans/listVansReducer";



const persistConfig = {
  key: "root12345",
  storage: storage,
  whitelist: [],
};

const rootReducer = combineReducers({
    
    us: userReducer,
    usersList: listUsersReducer,
    navbar: setHideNavbarReducer,
    vansList: listVansReducer
  
    
 
});

export default persistReducer(persistConfig, rootReducer);
